import React from "react";

/* eslint-disable */
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const icon = require("../../../assets/Detasad Cloud/main_icon_highperformance.svg");

const HostedSharePoint = () => {
    const heading = `HOSTED SHAREPOINT`;
    const details = `Share and collaborate with your team with DETASAD’s SharePoint service, that is purpose built for you.`;

    const overview = [
        `DETASAD SharePoint service enables your organization to easily provision and manage team sites for collaboration and sharing. Your employees can now share ideas, read the company-related news, share documents, and collaborate with DETASAD’s Hosted SharePoint Service.`
    ];

    const advantages = [
        [
            `File Management & Sharing`,
            `DETASAD offers you a metadata system where your team can upload and manage documents.`,
            icon
        ],
        [
            `External Sharing`,
            `Securely share files and content with people inside and outside of your organization.`,
            icon
        ],
        [
            `Team Sites`,
            `Provide a place for your team to organize and collaborate on content, data, and news to stay on the same page.`,
            icon
        ],
        [`Discovery`, `Discover relevant people and important content when you need it most.`, icon]
    ];

    const functions = [
        [
            `Sharing and Collaboration`,
            [
                `You can empower your team with an easy sharing and collaboration using DETASAD’s SharePoint service. You can also give people access to sites where they can organize and collaborate on content, data, and news to stay on the same page.`
            ]
        ],
        [
            `Connect Your Organization`,
            [
                `By using DETASAD SharePoint, you can keep your team informed with the latest news and let them collaborate over content. You can share common resources and applications and broadcast your message with rich, dynamic pages.`
            ]
        ],
        [
            `Intelligence and Insight`,
            [
                `DETASAD SharePoint let you rely on powerful enterprise search to find files, people and sites. It has a built-in intelligence which provides the most accurate results and helps you discover information when you need it.`
            ]
        ]
    ];

    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-collab"/>
            <SubNav overview={overview} advantages={advantages} functions={functions} />
            <Footer />
        </div>
    );
};

export default HostedSharePoint;
